import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

// 引入验证模块
import './init/validate.js';
// 引入有赞
import './init/vant.js';
// 引入自定义模块
import './init/custom.js';

// 引入多皮肤模块
import './init/multi.js';


// 引入调试模块
import VConsole from 'vconsole'
// 开发生产环境不启用
if (!['prod', 'dev'].includes(process.env.VUE_APP_CURRENTMODE)) {
    new VConsole()
}

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')